/* istanbul ignore file */
import { graph } from '@adc/constants'
import { AuctionBlueprintOnlineReactiveArgs } from '@adc/blueprint'
import _cx from 'classnames/bind'
// @ts-ignore no types
import _ from 'lodash'
import {
  formatMoney,
  formatNumber,
  formatPropertyType,
  fullForm,
} from '../../../utils/formatters'
import { getMarketingAttribute } from '../../../utils/graph'
// @ts-ignore no types
import cls from './index.scss'

export type ListingValueField = {
  label: string
  value: string
  elmId: string
  format?: (param?: string) => string
  hideIfNull?: boolean
}

export const getFieldListings = (
  listing: AuctionBlueprintOnlineReactiveArgs['listing']
): ListingValueField[] => {
  const { show: displayTrusteeSaleNo, label: trusteeSaleNoAltText } =
    getMarketingAttribute(
      listing,
      graph.enums.MarketingAttributeType.TRUSTEE_SALE_NUMBER
    )
  const fieldsListing: ListingValueField[] = [
    {
      label: 'Beds',
      value: String(listing?.primary_property.summary?.total_bedrooms || ''),
      elmId: 'total_bedrooms',
      format: formatNumber,
    },
    {
      label: 'Baths',
      value: String(listing?.primary_property?.summary?.total_bathrooms || ''),
      elmId: 'total_bathrooms',
      format: formatNumber,
    },
    {
      label: 'Square Footage',
      value: String(listing?.primary_property?.summary?.living_size || ''),
      elmId: 'interior_square_footage',
      format: formatNumber,
    },
    {
      label: 'Lot Size (Acres)',
      value: String(listing?.primary_property?.summary?.lot_size || ''),
      elmId: 'exterior_acerage',
      format: formatNumber,
    },
    {
      label: 'Property Type',
      value: String(
        listing?.primary_property?.summary?.structure_type_code || ''
      ),
      elmId: 'property_type',
      format: formatPropertyType,
    },
    {
      label: 'Year Built',
      value: String(listing?.primary_property?.summary?.year_built || ''),
      elmId: 'year_built',
    },
    {
      label: 'Monthly HOA Dues',
      value: String(listing?.listing_configuration?.monthly_hoa_amount || ''),
      elmId: 'hoa_dues',
      format: formatMoney,
      hideIfNull: true,
    },
  ]
  if (displayTrusteeSaleNo) {
    fieldsListing.push({
      label: trusteeSaleNoAltText || 'Foreclosure / Trustee No.',
      value: String(listing?.trustee_sale_number || ''),
      elmId: 'trusteeSaleNo',
      format: fullForm,
      hideIfNull: true,
    })
  }
  fieldsListing.push({
    label: 'APN',
    value: String(listing?.primary_property?.summary?.apn || ''),
    elmId: 'apn',
    format: fullForm,
    hideIfNull: true,
  })
  return fieldsListing
}

// Gets rid of any fields that we wouldn't show anyways, then chunks the array into pairs
export const pruneFields = (
  listing: AuctionBlueprintOnlineReactiveArgs['listing']
) =>
  _.chunk(
    // FIELDS
    getFieldListings(listing).filter(
      field => !field.hideIfNull || getFieldValue(field)
    ),
    2
  )

export const getFieldValue = (fieldInfo: ListingValueField) => {
  const val = fieldInfo.value || (fieldInfo.hideIfNull ? undefined : '-')
  return _.isFunction(fieldInfo.format) ? fieldInfo.format?.(val) : val
}
